import React from 'react';

const Members = () => {
  const members = [
    { id: 1, name: "Kseniia", role: "Organizer", avatar: "https://i.pravatar.cc/150?img=30" },
    { id: 2, name: "Sophia", role: "Member", avatar: "https://i.pravatar.cc/150?img=29" },
    { id: 3, name: "Olivia", role: "Member", avatar: "https://i.pravatar.cc/150?img=28" },
    { id: 4, name: "Ava", role: "Member", avatar: "https://i.pravatar.cc/150?img=40" },
    { id: 5, name: "Theodora", role: "Member", avatar: "https://i.pravatar.cc/150?img=1" },
  ];

  return (
    <div className="row-span-1 p-4 shadow-lg drop-shadow-lg text-slate-900 bg-slate-100 rounded-xl lg:col-span-4">
      <h2 className="pt-1 pb-2 pl-2 text-3xl font-extrabold leading-tight font-playfair-display">
        Members
      </h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {members.map(member => (
          <div key={member.id} className="flex items-center p-2 bg-white rounded-md shadow">
            <img src={member.avatar} alt={member.name} className="w-12 h-12 rounded-full" />
            <div className="ml-4">
              <p className="text-lg font-semibold">{member.name}</p>
              <p className="text-sm text-gray-500">{member.role}</p>
            </div>
          </div>
        ))}
      </div>
      <p className="pt-4 text-right text-gray-500">5/15 Members</p>
    </div>
  );
};

export default Members;